export default __webpack_public_path__ + "static/media/honeymoon7.e50dbf3c.webp";